<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [
        { key: 'search' },
        { key: 'isActive', component: 'checkbox' },
      ],
    }"
    :headers="docTypeDefinitionListHeaders"
    :request-func="docTypeDefinitionList"
    @click:row="openSingle">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Створити тип документа
      </v-btn>
    </template>
    <template #item.name="{ item }">
      <span class="font-weight-bold">{{ item.name }}</span>
    </template>
    <template #item.code="{ item }">
      <v-chip color="grey" density="compact" rounded="lg" size="small">
        <span class="font-weight-bold text-grey-darken-2">
          {{ item.code }}
        </span>
      </v-chip>
    </template>
    <template #bottom></template>
    <template #item.docTypeClass="{ item }">
      {{ item.docTypeClass?.name || '—' }}
    </template>
    <template #item.registrationMarkType="{ item }">
      {{ item.registrationMarkType || '—' }}
    </template>
    <template #item.isActive="{ item }">
      <v-chip :color="item.isActive ? 'success' : 'error'" size="small">
        {{ item.isActive ? 'Активний' : 'Неактивний' }}
      </v-chip>
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Переглянути',
            action: () => openSingle(item),
            icon: 'mdi-eye',
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: item.isActive ? 'Деактивувати' : 'Активувати',
            action: () => toggleActive(item),
            icon: item.isActive ? 'mdi-close-circle' : 'mdi-check-circle',
            listItemProps: {
              class: 'text-error',
            },
            iconProps: {
              color: 'error',
            },
          },
          {
            title: 'Видалити',
            action: () => deleteItem(item),
            icon: 'mdi-delete-forever',
            listItemProps: {
              class: 'text-error',
            },
          },
        ]">
      </b-action-menu>
    </template>
  </b-server-table>
</template>
<script lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { openDialog } from '@/dialog'
import { confirm } from 'best-modules/plugins'
import { BActionMenu, BServerTable } from 'best-modules/components/index'
import {
  docTypeClassList,
  docTypeDefinitionActivate,
  docTypeDefinitionDeactivate,
  docTypeDefinitionDelete,
  docTypeDefinitionList,
} from '@/requests/documentType'
import { docTypeDefinitionListHeaders } from '@/utils/tableHeaders'
import { DocumentTypeDefinition } from '@/utils/types/documentType'
import { DocumentClassType } from '@/utils/types/documentClassType'

export default {
  name: 'DocTypeDefinitionList',
  components: { BActionMenu, BServerTable },
  data() {
    return {
      docTypeDefinitionListHeaders,
    }
  },
  methods: { docTypeDefinitionList },
  setup() {
    const router = useRouter()
    const tableRenderKey = ref(1)
    const docTypeClasses = ref<DocumentClassType[]>([])

    const openSingle = (item: DocumentTypeDefinition) => {
      router.push({
        name: 'doc-type-definition-single',
        params: { id: item.id },
      })
    }

    const openCreateDialog = () => {
      openDialog({
        name: 'DocTypeDefinition',
        action: 'create',
        params: {
          title: 'Створити тип документа',
          submitLabel: 'Створити',
          cb: (res: DocumentTypeDefinition) => {
            router.push({
              name: 'doc-type-definition-single',
              params: { id: res.id },
            })
          },
        },
        dialogData: { docTypeClasses: docTypeClasses.value },
      })
    }

    const toggleActive = (item: DocumentTypeDefinition) => {
      const url = item.isActive
        ? docTypeDefinitionDeactivate
        : docTypeDefinitionActivate

      return url(item.id).then(() => {
        tableRenderKey.value += 1
      })
    }

    const deleteItem = (item: DocumentTypeDefinition) => {
      confirm({
        text: `Ви впевнені, що хочете видалити тип документа "${item.name}"?`,
      }).then(() => {
        return docTypeDefinitionDelete(item.id).then(() => {
          tableRenderKey.value += 1
        })
      })
    }

    onMounted(() => {
      docTypeClassList().then(res => {
        docTypeClasses.value = res.data
      })
    })

    return {
      openCreateDialog,
      openSingle,
      tableRenderKey,
      docTypeClasses,
      toggleActive,
      deleteItem,
    }
  },
}
</script>
